import { useState, useEffect } from 'react';
import { customersAPI } from '../../services/api';
import { Users, Search, Ban, Tag, MoreVertical, MessageSquare, Filter, X, CheckCircle } from 'lucide-react';
import { format } from 'date-fns';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const ChannelIcon = ({ channel, size = 14 }) => {
  if (channel === 'whatsapp') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#25D366">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
  if (channel === 'telegram') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#0088cc">
      <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
    </svg>
  );
  if (channel === 'facebook') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#1877F2">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );
  if (channel === 'instagram') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#E4405F">
      <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 11-2.882 0 1.441 1.441 0 012.882 0z"/>
    </svg>
  );
  return <MessageSquare size={size} style={{ color: 'var(--text-muted)' }} />;
};

const PRESET_LABELS = [
  { name: 'high priority', color: '#ef4444', bg: '#fee2e2' },
  { name: 'low priority', color: '#f59e0b', bg: '#fef3c7' },
  { name: 'follow up', color: '#3b82f6', bg: '#dbeafe' },
  { name: 'vip', color: '#8b5cf6', bg: '#ede9fe' },
  { name: 'new customer', color: '#10b981', bg: '#d1fae5' },
];

export default function CustomersPage() {
  const navigate = useNavigate();
  const [labelColors] = useState(() => {
    try { return JSON.parse(localStorage.getItem('inbox_label_colors') || '{}'); } catch { return {}; }
  });
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [blockingId, setBlockingId] = useState(null);

  useEffect(() => {
    fetchCustomers();
  }, [search, page]);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const { data } = await customersAPI.list({ search, page, limit: 20 });
      setCustomers(data.data.customers);
      setTotal(data.data.total);
    } catch (_) {}
    finally { setLoading(false); }
  };

  const toggleBlock = async (customer) => {
    setBlockingId(customer._id);
    try {
      const { data } = await customersAPI.block(customer._id, {
        isBlocked: !customer.isBlocked,
        reason: customer.isBlocked ? null : 'Blocked by admin',
      });
      setCustomers(prev => prev.map(c => c._id === customer._id ? { ...c, isBlocked: data.data.isBlocked } : c));
      toast.success(data.data.isBlocked ? 'Customer blocked' : 'Customer unblocked');
    } catch (_) {}
    finally { setBlockingId(null); }
  };

  const updateStatus = async (id, status) => {
    try {
      await customersAPI.update(id, { conversationStatus: status });
      setCustomers(prev => prev.map(c => c._id === id ? { ...c, conversationStatus: status } : c));
    } catch (_) {}
  };

  const getLabelStyle = (tag) => {
    const saved = labelColors[tag.toLowerCase()];
    if (saved) return { background: saved.bg, color: saved.color, border: `1px solid ${saved.color}50` };
    const preset = PRESET_LABELS.find(p => p.name === tag.toLowerCase());
    return preset
      ? { background: preset.bg, color: preset.color, border: `1px solid ${preset.color}30` }
      : { background: 'var(--border)', color: 'var(--text-muted)', border: '1px solid var(--border)' };
  };

  const statusBadge = (status) => {
    const map = { open: 'badge-green', pending: 'badge-yellow', resolved: 'badge-blue', spam: 'badge-red' };
    return <span className={`badge ${map[status] || 'badge-gray'}`}>{status}</span>;
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Customers</h1>
          <p className="page-subtitle">{total.toLocaleString()} total customers across all channels</p>
        </div>
      </div>

      <div className="page-body">
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="flex-between" style={{ flexWrap: 'wrap', gap: 10 }}>
            <div className="search-box" style={{ maxWidth: 320 }}>
              <Search size={14} />
              <input className="form-input" style={{ paddingLeft: 34 }} placeholder="Search by name, phone, email…"
                value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />
            </div>
            <div className="text-muted">{total} customers</div>
          </div>
        </div>

        <div className="card" style={{ padding: 0 }}>
          <div className="table-container">
            {loading ? (
              <div className="flex-center" style={{ padding: 60 }}><div className="spinner" /></div>
            ) : customers.length === 0 ? (
              <div className="empty-state" style={{ padding: 60 }}>
                <Users size={36} /><h3>No customers yet</h3>
                <p>Customers will appear here when they message you</p>
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Channels</th>
                    <th>Status</th>
                    <th>Last Message</th>
                    <th>Labels</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {customers.map(customer => (
                    <tr key={customer._id}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <div className="avatar avatar-sm">{(customer.name || '?')[0].toUpperCase()}</div>
                          <div>
                            <div style={{ fontWeight: 600, fontSize: '0.875rem' }}>
                              {customer.name}
                              {customer.isBlocked && <span className="badge badge-red" style={{ marginLeft: 6, fontSize: '0.68rem' }}>blocked</span>}
                            </div>
                            <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{customer.phone || customer.email || '—'}</div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                          {customer.channelIds?.map(ch => (
                            <span key={ch.channel} title={`${ch.channel}: ${ch.externalId}`} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                              <ChannelIcon channel={ch.channel} size={16} />
                              <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>{ch.externalId}</span>
                            </span>
                          ))}
                        </div>
                      </td>
                      <td>{statusBadge(customer.conversationStatus)}</td>
                      <td>
                        <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                          {customer.lastMessageAt ? format(new Date(customer.lastMessageAt), 'MMM d, HH:mm') : '—'}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                          {customer.tags?.slice(0, 3).map(tag => (
                            <span key={tag} style={{ fontSize: '0.68rem', padding: '2px 7px', borderRadius: 99, fontWeight: 600, ...getLabelStyle(tag) }}>{tag}</span>
                          ))}
                          {(customer.tags?.length || 0) > 3 && (
                            <span style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>+{customer.tags.length - 3}</span>
                          )}
                        </div>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button className="btn btn-ghost btn-sm" title="View conversation"
                            onClick={() => navigate('/dashboard/inbox', { state: { customerId: customer._id } })}>
                            <MessageSquare size={13} />
                          </button>
                          <button className={`btn btn-sm ${customer.isBlocked ? 'btn-secondary' : 'btn-ghost'}`}
                            disabled={blockingId === customer._id}
                            onClick={() => toggleBlock(customer)}
                            title={customer.isBlocked ? 'Unblock' : 'Block'}>
                            {customer.isBlocked ? <CheckCircle size={13} color="var(--green)" /> : <Ban size={13} />}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Pagination */}
        {total > 20 && (
          <div className="flex-between" style={{ marginTop: 16 }}>
            <span className="text-muted">Page {page} of {Math.ceil(total / 20)}</span>
            <div style={{ display: 'flex', gap: 6 }}>
              <button className="btn btn-secondary btn-sm" disabled={page === 1} onClick={() => setPage(p => p - 1)}>Previous</button>
              <button className="btn btn-secondary btn-sm" disabled={page >= Math.ceil(total / 20)} onClick={() => setPage(p => p + 1)}>Next</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
